<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex burger-spacing justify-content-between">
        <back-arrow :title="(isEdition? $t('Modify') + ' ' + $t('l.i'): $t('Submit') + ' ' + $t('a')  + ' ') +  $t('project')"/>
      </div>

      <b-form ref="form" @submit.stop.prevent="onSubmit">

        <!-- cadre des champs de modification réservés aux commissions/admins -->
        <div v-if="!$store.getters.isUser">
          <div class="page-title mt-4">
            {{$t('project.Infos') + ' ' + $t('Commission')}}
          </div>

          <div class="row mt-2">
            <div class="col-md-12">
              <b-card class="mt-2 mb-4 shadow-sm">

                <div class="row">

                  <!-- status -->
                  <div class="col-md-12">
                    <select-field
                      :label="$t('ProjectStatus')"
                      :id="'status-input'"
                      :select-value="this.form.projectStatus"
                      v-model="this.form.projectStatus"
                      :options="availableStatusForCommission"
                      :is-enum="true"
                      :is-required="true">
                    </select-field>
                  </div>

                  <!-- intéressant pour le service com -->
                  <div class="col-md-12">
                    <b-form-checkbox
                      id="isComRelevant-input"
                      name="isComRelevant-input"
                      v-model="form.isComRelevant.value"
                      :value="true">
                      {{ $t('project.IsComRelevant')}}
                    </b-form-checkbox>
                  </div>

                  <!-- budget demandé -->
                  <div class="col-md-6">
                    <b-form-checkbox
                      id="budgetNeeded-input"
                      name="BudgetNeeded-input"
                      class="mt-4 mb-5"
                      v-model="form.budgetNeeded.value"
                      :value="true">
                      {{ $t('project.BudgetNeeded')}}
                    </b-form-checkbox>
                  </div>

                  <!-- montant du budget -->
                  <div class="col-md-6">
                    <price-field
                      v-if="this.form.budgetNeeded.value"
                      :label="$t('project.Budget')"
                      :id="'budget-input'"
                      :price="this.form.budget"
                      v-model="this.form.budget">
                    </price-field>
                  </div>

                  <!-- commentaire de la commission -->
                  <div class="col-md-12">
                    <text-area-field
                      :label="$t('project.CommissionComment')"
                      :id="'commissionComment-input'"
                      :text-area-value="this.form.commissionComment"
                      v-model="this.form.commissionComment"
                      :info="$t('project.CommissionComment.info')">
                    </text-area-field>
                  </div>

                  <!-- message de la commission au porteur -->
                  <div class="col-md-12">
                    <text-area-field
                      v-if="displayMessage"
                      :label="$t('project.Message') + $t('field.mandatory')"
                      :id="'message-input'"
                      :text-area-value="this.form.message"
                      v-model="this.form.message"
                      :is-required="true">
                    </text-area-field>
                  </div>

                  <!-- si le projet est dans un autre état: bouton valider -->
                  <div class="col-md-12">
                    <div class="d-flex justify-content-end mt-4">
                      <b-button type="submit" variant="secondary" @click="isSubmited = false;">
                        <span v-if="!isLoading">{{ $t('Update') }}</span>
                        <b-spinner v-else :label="$t('spinner.isLoading')" small></b-spinner>
                      </b-button>
                    </div>
                  </div>

                </div>

              </b-card>
            </div>
          </div>

          <div class="page-title mt-4">
            {{$t('project.Infos') + ' ' + $t('Project')}}
          </div>
        </div>

        <!-- formulaire de modification d'un project -->
        <div class="row mt-2">
          <div class="col-md-12">
            <b-card class="mt-2 mb-4 shadow-sm">

              <div class="row">
                <div class="col-md-12">

                  <!-- infos de l'évènement -->
                  <div class="section-title mb-3">{{$t('project.section.Infos')}}</div>
                  <div class="bold-text mb-4">{{$t('project.Infos.subtitle')}}</div>

                  <!-- titre -->
                  <string-field
                    :label="$t('project.Name') + $t('field.mandatory')"
                    :id="'name-input'"
                    :input-value="this.form.name"
                    v-model="this.form.name"
                    :placeholder="$t('project.Name.placeholder')"
                    :is-required="true">
                  </string-field>

                  <!-- image -->
                  <image-field
                    :id="'image-input'"
                    :label="$t('project.ProjectImage') + $t('field.mandatory')"
                    :placeholder="$t('project.ProjectImage')"
                    :image="form.image"
                    :size-details="$t('project.ProjectImage.sizeDetails')"
                    :format-details="$t('project.ProjectImage.formatDetails')"
                    :other-details="$t('project.ProjectImage.otherDetails')"
                    :is-required="isSubmited && !this.form.image.src">
                  </image-field>

                  <!-- description -->
                  <rich-text-field
                    :label="$t('project.Description') + $t('field.mandatory')"
                    :id="'description-input'"
                    :input-value="this.form.description"
                    v-model="this.form.description"
                    :placeholder="$t('project.Description.placeholder')"
                    :is-required="isSubmited">
                  </rich-text-field>

                  <!-- types -->
                  <select-tags-field
                    :label="$t('ProjectTypes') + $t('field.mandatory')"
                    :id="'projectTypes-component-select'"
                    :no-selection="$t('projectType.noSelection')"
                    :items="this.projectTypes"
                    :items-init="this.initProjectTypes"
                    :is-required="isSubmited"
                    @didChangeSelectedItems="didChangeSelectedProjectTypes">
                  </select-tags-field>

                  <!-- commission -->
                  <select-field
                    :label="$t('Commission') + $t('field.mandatory')"
                    :id="'commissionId-input'"
                    :select-value="this.form.commissionId"
                    v-model="this.form.commissionId"
                    :options="commissions"
                    :is-required="isSubmited">
                  </select-field>

                  <!-- isFree -->
                  <select-boolean-field
                    :label="$t('project.IsFree') + $t('field.mandatory')"
                    :select-value="this.form.isFree"
                    v-model="this.form.isFree"
                    :is-required="isSubmited">
                  </select-boolean-field>

                  <!-- priceDetails -->
                  <string-field
                    v-if="form.isFree.value === false"
                    :label="$t('project.PriceDetails') + $t('field.mandatory')"
                    :id="'priceDetails-input'"
                    :input-value="this.form.priceDetails"
                    v-model="this.form.priceDetails"
                    :placeholder="$t('project.PriceDetails.placeholder')"
                    :is-required="isSubmited">
                  </string-field>

                  <!-- projectAccess -->
                  <select-field
                    :label="$t('ProjectAccess') + $t('field.mandatory')"
                    :id="'projectAccess-input'"
                    :select-value="this.form.projectAccess"
                    v-model="this.form.projectAccess"
                    :options="projectAccesss"
                    :is-enum="true"
                    :is-required="isSubmited">
                  </select-field>

                  <!-- projectPublic -->
                  <select-field
                    :label="$t('ProjectPublic') + $t('field.mandatory')"
                    :id="'projectPublic-input'"
                    :select-value="this.form.projectPublic"
                    v-model="this.form.projectPublic"
                    :options="projectPublics"
                    :is-enum="true"
                    :is-required="isSubmited">
                  </select-field>

                  <!-- Section lieu de l'évènement -->
                  <div class="section p-3 mb-4">
                    <div class="row">

                      <div class="col-md-12 section-title mb-4">{{$t('project.section.Place')}}</div>

                      <!-- nom du lieu -->
                      <div class="col-md-12">
                        <autocomplete-field
                          :label="$t('projectPlace.Name') + $t('field.mandatory')"
                          :id="'placeName-input'"
                          :input-value="this.form.place.name"
                          v-model="this.form.place.name"
                          :items="projectPlaces"
                          :placeholder="$t('projectPlace.Name.placeholder')"
                          :is-required="isSubmited"
                          @elementValueChanged="selectedProjectPlace">
                        </autocomplete-field>
                      </div>

                      <div class="col-md-12">
                        <div class="separator mb-4"/>
                      </div>

                      <!-- adresse du lieu -->
                      <div class="col-md-12">
                        <map-autocomplete-field
                          :label="$t('projectPlace.Address') + $t('field.mandatory')"
                          :id="'placeAddress-input'"
                          :address="this.form.place.address"
                          v-model="this.form.place.address"
                          :placeholder="$t('projectPlace.Address.placeholder')"
                          :is-required="isSubmited">
                        </map-autocomplete-field>
                      </div>

                      <!-- téléphone du lieu -->
                      <div class="col-md-6">
                        <phone-number-field
                          :phone-number="this.form.place.phoneNumber"
                          v-model="this.form.place.phoneNumber"
                          :is-required="false">
                        </phone-number-field>
                      </div>

                      <!-- site internet du lieu -->
                      <div class="col-md-6">
                        <string-field
                          :label="$t('projectPlace.Website')"
                          :id="'placeWebsite-input'"
                          :input-value="this.form.place.website"
                          :type="'url'"
                          v-model="this.form.place.website"
                          :placeholder="$t('projectPlace.Website.placeholder')">
                        </string-field>
                      </div>

                    </div>
                  </div>

                  <!-- Section dates de l'évènement -->
                  <template v-for="(projectDateConf, index) in projectDateConfs">
                    <project-date-component
                      :project-date-conf="projectDateConf"
                      v-model="projectDateConfs[index]"
                      :is-required="index === 0"
                      @removedProjectDateConf="removedProjectDateConf">
                    </project-date-component>
                  </template>

                  <b-button class="mb-4" variant="secondary" @click="addProjectDateConf(null)">{{ $t('project.add.date') }}</b-button>

                  <!-- Section organisateur de l'évènement -->
                  <div class="section p-3 mb-4">
                    <div class="row">

                      <div class="col-md-12 section-title mb-4">{{$t('project.section.Organizer')}}</div>

                      <!-- type de l'organisateur -->
                      <div class="col-md-12">
                        <string-field
                          :label="$t('projectOrganizer.Type') + $t('field.mandatory')"
                          :id="'organizerType-input'"
                          :input-value="this.form.organizer.type"
                          v-model="this.form.organizer.type"
                          :placeholder="$t('projectOrganizer.Type.placeholder')"
                          :info="$t('projectOrganizer.Type.infos')"
                          :is-required="isSubmited">
                        </string-field>
                      </div>

                      <!-- nom de l'organisateur -->
                      <div class="col-md-6">
                        <autocomplete-field
                          :label="$t('projectOrganizer.Name') + $t('field.mandatory')"
                          :id="'organizerName-input'"
                          :input-value="this.form.organizer.name"
                          v-model="this.form.organizer.name"
                          :items="projectOrganizers"
                          :placeholder="$t('projectOrganizer.Name.placeholder')"
                          :is-required="isSubmited"
                          @elementValueChanged="selectedProjectOrganizer">
                        </autocomplete-field>
                      </div>

                      <!-- site internet de l'organisateur -->
                      <div class="col-md-6">
                        <string-field
                          :label="$t('projectOrganizer.Website')"
                          :id="'organizerWebsite-input'"
                          :input-value="this.form.organizer.website"
                          :type="'url'"
                          v-model="this.form.organizer.website"
                          :placeholder="$t('projectOrganizer.Website.placeholder')">
                        </string-field>
                      </div>

                      <!-- nom du contact de l'organisateur -->
                      <div class="col-md-6">
                        <string-field
                          :label="$t('projectOrganizer.ContactLastname') + $t('field.mandatory')"
                          :id="'organizerContactLastname-input'"
                          :input-value="this.form.organizer.contactLastname"
                          v-model="this.form.organizer.contactLastname"
                          :placeholder="$t('projectOrganizer.ContactLastname.placeholder')"
                          :is-required="isSubmited">
                        </string-field>
                      </div>

                      <!-- prénom du contact de l'organisateur -->
                      <div class="col-md-6">
                        <string-field
                          :label="$t('projectOrganizer.ContactFirstname') + $t('field.mandatory')"
                          :id="'organizerContactFirstname-input'"
                          :input-value="this.form.organizer.contactFirstname"
                          v-model="this.form.organizer.contactFirstname"
                          :placeholder="$t('projectOrganizer.ContactFirstname.placeholder')"
                          :is-required="isSubmited">
                        </string-field>
                      </div>

                      <!-- téléphone du contact de l'organisateur -->
                      <div class="col-md-6">
                        <phone-number-field
                          :label="$t('projectOrganizer.ContactPhoneNumber') + $t('field.mandatory')"
                          :phone-number="this.form.organizer.contactPhoneNumber"
                          v-model="this.form.organizer.contactPhoneNumber"
                          :is-required="isSubmited">
                        </phone-number-field>
                      </div>

                      <!-- email du contact de l'organisateur -->
                      <div class="col-md-6">
                        <string-field
                          :label="$t('projectOrganizer.ContactEmail') + $t('field.mandatory')"
                          :id="'organizerContactEmail-input'"
                          :input-value="this.form.organizer.contactEmail"
                          v-model="this.form.organizer.contactEmail"
                          :placeholder="$t('projectOrganizer.ContactEmail.placeholder')"
                          :type="'email'"
                          :is-required="isSubmited">
                        </string-field>
                      </div>

                    </div>
                  </div>

                  <!-- Section réseaux sociaux de l'évènement -->
                  <div class="section p-3 mb-4">
                    <div class="row">

                      <div class="col-md-12 section-title mb-4">{{$t('project.section.Network')}}</div>

                      <!-- site internet de l'évènement -->
                      <div class="col-md-12">
                        <string-field
                          :label="$t('project.ProjectLink')"
                          :id="'projectLink-input'"
                          :input-value="this.form.projectLink"
                          :type="'url'"
                          v-model="this.form.projectLink"
                          :placeholder="$t('project.ProjectLink.placeholder')">
                        </string-field>
                      </div>

                      <!-- lien facebook de l'évènement -->
                      <div class="col-md-6">
                        <string-field
                          :label="$t('project.FacebookLink')"
                          :id="'facebookLink-input'"
                          :input-value="this.form.facebookLink"
                          :type="'url'"
                          v-model="this.form.facebookLink"
                          :placeholder="$t('project.FacebookLink.placeholder')">
                        </string-field>
                      </div>

                      <!-- lien instagram de l'évènement -->
                      <div class="col-md-6">
                        <string-field
                          :label="$t('project.InstagramLink')"
                          :id="'instagramLink-input'"
                          :input-value="this.form.instagramLink"
                          :type="'url'"
                          v-model="this.form.instagramLink"
                          :placeholder="$t('project.InstagramLink.placeholder')">
                        </string-field>
                      </div>

                    </div>
                  </div>

                  <!-- commentaire du créateur -->
                  <text-area-field
                    :label="$t('project.UserComment')"
                    :id="'userComment-input'"
                    :text-area-value="this.form.userComment"
                    v-model="this.form.userComment"
                    :placeholder="$t('project.UserComment.placeholder')">
                  </text-area-field>

                  <!-- règlement -->
                  <b-form-checkbox
                    v-if="isCreation || isDuplication || isDraft"
                    id="rules-input"
                    name="rules-input"
                    :required="isSubmited">
                    {{ $t('project.RulesAcceptance') + ' ' }}
                    <b-link v-on:click="showRulesModal" class="">{{ $t('project.Rules') }}</b-link>
                    {{$t('field.mandatory')}}
                  </b-form-checkbox>

                  <!-- RGPD -->
                  <b-form-checkbox
                    v-if="isCreation || isDuplication || isDraft"
                    id="rgpd-input"
                    name="rgpd-input"
                    :required="isSubmited">
                    <p>{{ $t('user.rgpd')}} <b-link href="https://quinzaine.japonoccitanie.fr/politique-de-confidentialite/" target="_blank">{{$t('user.policy')}}.</b-link></p>
                    <p>{{ $t('user.rgpd2')}} <b-link href="mailto:mesdonnees@japonoccitanie.fr">mesdonnees@japonoccitanie.fr</b-link> {{$t('field.mandatory')}}</p>
                  </b-form-checkbox>

                  <!-- propriété des droits -->
                  <b-form-checkbox
                    v-if="isCreation || isDuplication || isDraft"
                    id="owner-input"
                    name="owner-input"
                    :required="isSubmited">
                    {{ $t('project.ownerAcceptance') + $t('field.mandatory')}}
                  </b-form-checkbox>

                </div>
              </div>

              <!-- Si le project est créé ou en brouillon: boutons enregistrer en brouillon ou soumettre -->
              <div class="d-flex justify-content-end mt-4" v-if="isCreation || isDuplication || isDraft">
                <b-button type="submit" variant="secondary" @click="isSubmited = false;">
                  <span v-if="!isLoading">{{ $t('project.saveDraft') }}</span>
                  <b-spinner v-else :label="$t('spinner.isLoading')" small></b-spinner>
                </b-button>
                <b-button type="submit" variant="primary" class="ml-3" @click="isSubmited = true;">
                  <span v-if="!isLoadingSubmited">{{ $t('Submit') + ' ' + $t('l.i') +  $t('project') }}</span>
                  <b-spinner v-else :label="$t('spinner.isLoading')" small></b-spinner>
                </b-button>
              </div>

              <!-- si le projet est dans un autre état: bouton valider -->
              <div class="d-flex justify-content-end mt-4" v-else>
                <b-button type="submit" variant="secondary">
                  <span v-if="!isLoading">{{ $t('Update') }}</span>
                  <b-spinner v-else :label="$t('spinner.isLoading')" small></b-spinner>
                </b-button>
              </div>

              <!-- error message -->
              <div class="errorMessage d-flex justify-content-end" v-if="!checkFormValidity">{{errorMessage}}</div>

            </b-card>
          </div>
        </div>
      </b-form>

      <project-rules-modal/>

    </b-container>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import PhoneNumberField from "../../components/b122/editFields/PhoneNumberField.vue"
import SelectTagsField from "../../components/b122/editFields/SelectTagsField.vue"
import PriceField from "../../components/b122/editFields/PriceField.vue"
import ProjectRulesModal from "./components/ProjectRulesModal.vue"
import ImageField from "../../components/b122/editFields/ImageField.vue"
import ProjectDateComponent from "./components/ProjectDateComponent.vue"
import StringField from "../../components/b122/editFields/StringField.vue"
import TextAreaField from "../../components/b122/editFields/TextAreaField.vue"
import SelectField from "../../components/b122/editFields/SelectField.vue"
import RichTextField from "../../components/b122/editFields/RichTextField.vue"
import MapAutocompleteField from "../../components/b122/editFields/MapAutocompleteField.vue"
import SelectBooleanField from "../../components/b122/editFields/SelectBooleanField.vue"
import AutocompleteField from "../../components/b122/editFields/AutocompleteField.vue"

export default {

  name: 'ProjectCreate',

  components: {
    AutocompleteField,
    SelectBooleanField,
    MapAutocompleteField,
    RichTextField,
    SelectField,
    TextAreaField,
    StringField,
    ProjectDateComponent,
    ImageField,
    ProjectRulesModal,
    PriceField,
    SelectTagsField,
    PhoneNumberField,
    BackArrow
  },

  data () {
    return {
      // paramètres
      projectId: this.$route.params.projectId,
      duplicateProjectId: this.$route.params.duplicateProjectId,
      // donnees du composant
      project: null,
      isDuplication: null,
      isEdition: null,
      isCreation: null,
      isLoading: false,
      isLoadingSubmited: false,
      isDraft: false,
      isSubmited: false,
      errorMessage: null,
      submissionErrorTitle: this.$t('error.mandatory.fields.missing'),
      // listes
      availableStatusForCommission: [],
      projectTypes: [],
      initProjectTypes: [],
      selectedProjectTypesIds: [],
      commissions: [],
      projectAccesss: [],
      projectPublics: [],
      projectPlaces: [],
      projectOrganizers: [],
      projectDateConfs: [],
      removedProjectDateConfsIds: [],
      // formulaire
      form: {
        name:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        description:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        image: {
          state: null,
          invalidFeedback: null,
          value: null,
          src: null,
          id: null
        },
        commissionId:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        isFree: {
          state: null,
          invalidFeedback: null,
          value: true
        },
        priceDetails:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        projectAccess:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        projectPublic: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        projectLink:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        facebookLink:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        instagramLink:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        userComment:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        projectStatus: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        isComRelevant: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        budgetNeeded:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        budget:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        commissionComment:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        message:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        place: {
          name: {
            state: null,
            invalidFeedback: null,
            value: null
          },
          address: {
            state: null,
            invalidFeedback: null,
            value: null,
            latitude: null,
            longitude: null,
            city: null,
            department: null
          },
          phoneNumber: {
            state: null,
            invalidFeedback: null,
            value: null,
            formattedNumber: null,
            countryCode: null
          },
          website: {
            state: null,
            invalidFeedback: null,
            value: null
          }
        },
        organizer: {
          type: {
            state: null,
            invalidFeedback: null,
            value: null
          },
          name: {
            state: null,
            invalidFeedback: null,
            value: null
          },
          website: {
            state: null,
            invalidFeedback: null,
            value: null
          },
          contactFirstname: {
            state: null,
            invalidFeedback: null,
            value: null
          },
          contactLastname: {
            state: null,
            invalidFeedback: null,
            value: null
          },
          contactPhoneNumber: {
            state: null,
            invalidFeedback: null,
            value: null,
            formattedNumber: null,
            countryCode: null
          },
          contactEmail: {
            state: null,
            invalidFeedback: null,
            value: null
          }
        }
      }
    }
  },

  computed: {

    displayMessage() {
      return this.form.projectStatus.value === 'REFUSED'
        || this.form.projectStatus.value === 'INFOS_NEEDED'
        || this.form.projectStatus.value === 'CERTIFIED_UNPUBLISHED_INFOS_NEEDED'
    },

    // vérification de la validité du formulaire
    checkFormValidity() {
      let isValid = true
      if (this.form.name.state === false
        || this.form.image.state === false
        || this.form.description.state === false
        || this.form.commissionId.state === false
        || this.form.isFree.state === false
        || this.form.priceDetails.state === false
        || this.form.projectAccess.state === false
        || this.form.projectPublic.state === false
        || this.form.place.name.state === false
        || this.form.place.address.state === false
        || this.form.place.phoneNumber.state === false
        || this.form.place.website.state === false
        || this.form.organizer.type.state === false
        || this.form.organizer.name.state === false
        || this.form.organizer.website.state === false
        || this.form.organizer.contactLastname.state === false
        || this.form.organizer.contactFirstname.state === false
        || this.form.organizer.contactEmail.state === false
        || this.form.organizer.contactPhoneNumber.state === false
        || this.form.projectLink.state === false
        || this.form.facebookLink.state === false
        || this.form.instagramLink.state === false
        || this.form.userComment.state === false
        || this.form.projectStatus.state === false
        || this.form.isComRelevant.state === false
        || this.form.budgetNeeded.state === false
        || this.form.budget.state === false
        || this.form.commissionComment.state === false
        || this.form.message.state === false) {
        isValid = false
      }
      this.projectDateConfs.forEach((dateConf) => {
        if (dateConf.date.state === false || dateConf.startTime.state === false || dateConf.endTime.state === false) {
          isValid = false
        }
      })
      this.errorMessage = isValid? null: this.$t('error.form.invalid')
      return isValid
    }

  },

  async mounted() {
    this.isDuplication = this.duplicateProjectId != null && this.duplicateProjectId !== 'undefined'
    this.isEdition = this.projectId != null && this.projectId !== 'undefined'
    this.isCreation = !this.isDuplication && !this.isEdition
    await this.fetchData()
    if (this.isCreation) {
      this.addProjectDateConf()
    }
  },

  methods: {

    async fetchData () {
      await this.fetchProjectTypes()
      await this.fetchCommissions()
      await this.fetchProjectAccesss()
      await this.fetchProjectPublics()
      await this.fetchProjectPlaces()
      await this.fetchProjectOrganizers()
      if (this.isDuplication) {
        this.fetchProject(this.duplicateProjectId)
      }
      else if (this.isEdition) {
        this.fetchProject(this.projectId)
      }
    },

    // récupération de la liste des projectTypes
    async fetchProjectTypes () {
      await api
        .get(`/projectType`)
        .then(response => {
          this.projectTypes = response.data
        })
    },

    // récupération de la liste des commissions
    async fetchCommissions () {
      await api
        .get(`/commission`)
        .then(response => {
          this.commissions = response.data
          if (this.isCreation) {
            this.form.commissionId.value = this.commissions.length > 0 ? this.commissions[0].id : null
          }
        })
    },

    // récupération de la liste des projectAccesss
    async fetchProjectAccesss () {
      await api
        .get(`/project/getProjectAccesss`)
        .then(response => {
          this.projectAccesss = response.data
          if (this.isCreation) {
            this.form.projectAccess.value = this.projectAccesss[0].value
          }
        })
    },

    // récupération de la liste des projectPublics
    async fetchProjectPublics () {
      await api
        .get(`/project/getProjectPublics`)
        .then(response => {
          this.projectPublics = response.data
          if (this.isCreation) {
            this.form.projectPublic.value = this.projectPublics[0].value
          }
        })
    },

    // récupération de la liste des projectPlaces pour l'autocomplete
    async fetchProjectPlaces () {
      await api
        .get(`/projectPlace/getAllForAutocomplete` + (this.isEdition? '/' + this.projectId: ''))
        .then(response => {
          this.projectPlaces = response.data
        })
    },

    // récupération de la liste des projectPlaces pour l'autocomplete
    async fetchProjectOrganizers () {
      await api
        .get(`/projectOrganizer/getAllForAutocomplete` + (this.isEdition? '/' + this.projectId: ''))
        .then(response => {
          this.projectOrganizers = response.data
        })
    },

    fetchProject (projectId) {
      api
        .get(`/project/${projectId}`)
        .then(response => {
          this.project = response.data
          this.initProjectTypes = this.project.projectTypes
          this.isDraft = this.project.projectStatus? (this.project.projectStatus.value === 'DRAFT' || this.project.projectStatus.value === 'DELETED'): false
          this.setInitialValues()
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'ProjectIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    // initialisation des données du projet
    setInitialValues () {
      this.availableStatusForCommission = this.project.availableStatusForCommission
      this.form.name.value = this.project.name
      this.form.image.src = this.project.projectImage? this.project.projectImage.fileUrl: null
      this.form.image.id = this.project.projectImage? this.project.projectImage.id: null
      this.form.description.value = this.project.description
      this.form.commissionId.value = this.project.commission? this.project.commission.id: null
      this.form.isFree.value = this.project.isFree
      this.form.priceDetails.value = this.project.priceDetails
      this.form.projectAccess.value = this.project.projectAccess? this.project.projectAccess.value: null
      this.form.projectPublic.value = this.project.projectPublic? this.project.projectPublic.value: null
      this.form.projectLink.value = this.project.projectLink
      this.form.facebookLink.value = this.project.facebookLink
      this.form.instagramLink.value = this.project.instagramLink
      this.form.userComment.value = this.project.userComment
      this.form.projectStatus.value = this.project.projectStatus.value
      this.form.isComRelevant.value = this.project.isComRelevant
      this.form.budgetNeeded.value = this.project.budgetNeeded
      this.form.budget.value = this.project.budget
      this.form.commissionComment.value = this.project.commissionComment
      if (!this.$store.getters.isUser) {
        this.form.message.value = this.project.message
      }
      if (this.project.projectPlace) {
        this.form.place.name.value = this.project.projectPlace.name
        this.form.place.address.value = this.project.projectPlace.address
        this.form.place.address.latitude = this.project.projectPlace.latitude
        this.form.place.address.longitude = this.project.projectPlace.longitude
        this.form.place.address.city = this.project.projectPlace.city
        this.form.place.address.department = this.project.projectPlace.department
        this.form.place.phoneNumber.value = this.project.projectPlace.phoneNumber
        this.form.place.phoneNumber.countryCode = this.project.projectPlace.phoneCountryCode
        this.form.place.website.value = this.project.projectPlace.website
      }
      if (this.project.projectOrganizer) {
        this.form.organizer.name.value = this.project.projectOrganizer.name
        this.form.organizer.type.value = this.project.projectOrganizer.organizerType
        this.form.organizer.website.value = this.project.projectOrganizer.website
        this.form.organizer.contactFirstname.value = this.project.projectOrganizer.contactFirstname
        this.form.organizer.contactLastname.value = this.project.projectOrganizer.contactLastname
        this.form.organizer.contactEmail.value = this.project.projectOrganizer.contactEmail
        this.form.organizer.contactPhoneNumber.value = this.project.projectOrganizer.contactPhoneNumber
        this.form.organizer.contactPhoneNumber.countryCode = this.project.projectOrganizer.phoneCountryCode
      }
      this.project.projectDateConfs.forEach(dateConf => {
        this.addProjectDateConf(dateConf)
      })
    },

    // mise à jour des projectTypes sélectionnés
    didChangeSelectedProjectTypes(selectedItemsIds) {
      this.selectedProjectTypesIds = selectedItemsIds
    },

    selectedProjectPlace(selectedElement) {
      const selectedProjectPlace = this.projectPlaces.find((place) => place === selectedElement)
      if (selectedProjectPlace) {
        this.form.place.address.value = selectedProjectPlace.address
        this.form.place.address.latitude = selectedProjectPlace.latitude
        this.form.place.address.longitude = selectedProjectPlace.longitude
        this.form.place.address.city = selectedProjectPlace.city
        this.form.place.address.department = selectedProjectPlace.department
        this.form.place.phoneNumber.value = selectedProjectPlace.phoneNumber
        this.form.place.phoneNumber.countryCode = selectedProjectPlace.phoneCountryCode
        this.form.place.website.value = selectedProjectPlace.website
      }
    },

    selectedProjectOrganizer(selectedElement) {
      const selectedProjectOrganizer = this.projectOrganizers.find((organizer) => organizer === selectedElement)
      if (selectedProjectOrganizer) {
        this.form.organizer.type.value = selectedProjectOrganizer.organizerType
        this.form.organizer.website.value = selectedProjectOrganizer.website
        this.form.organizer.contactFirstname.value = selectedProjectOrganizer.contactFirstname
        this.form.organizer.contactLastname.value = selectedProjectOrganizer.contactLastname
        this.form.organizer.contactEmail.value = selectedProjectOrganizer.contactEmail
        this.form.organizer.contactPhoneNumber.value = selectedProjectOrganizer.contactPhoneNumber
        this.form.organizer.contactPhoneNumber.countryCode = selectedProjectOrganizer.phoneCountryCode
      }
    },

    // ajout d'une date
    addProjectDateConf(dateConf) {
      const date = dateConf? new Date(dateConf.dateStringForInit): new Date()
      const weekDay = date.toLocaleDateString('en-EN', { weekday: 'long' })
      this.projectDateConfs.push({
        index: this.projectDateConfs.length,
        id: dateConf? dateConf.id: null,
        date: {
          value: (dateConf && dateConf.date)? new Date(dateConf.dateStringForInit): new Date(),
          state: null,
          invalidFeedback: null
        },
        startTime: {
          value: (dateConf && dateConf.startTime)? dateConf.startTime: new Date().toLocaleTimeString(),
          state: null,
          invalidFeedback: null
        },
        endTime: {
          value: (dateConf && dateConf.endTime)? dateConf.endTime: new Date().toLocaleTimeString(),
          state: null,
          invalidFeedback: null
        },
        isRecurrent: (dateConf && dateConf.isRecurrent)? dateConf.isRecurrent: false,
        dateRecurrenceType: (dateConf && dateConf.dateRecurrenceType)? dateConf.dateRecurrenceType: 'DAILY',
        recurrenceInterval: (dateConf && dateConf.recurrenceInterval)? dateConf.recurrenceInterval: 1,
        recurrenceMonday: (dateConf && dateConf.recurrenceMonday)? dateConf.recurrenceMonday: (weekDay === 'Monday'),
        recurrenceTuesday: (dateConf && dateConf.recurrenceTuesday)? dateConf.recurrenceTuesday: (weekDay === 'Tuesday'),
        recurrenceWednesday: (dateConf && dateConf.recurrenceWednesday)? dateConf.recurrenceWednesday: (weekDay === 'Wednesday'),
        recurrenceThursday: (dateConf && dateConf.recurrenceThursday)? dateConf.recurrenceThursday: (weekDay === 'Thursday'),
        recurrenceFriday: (dateConf && dateConf.recurrenceFriday)? dateConf.recurrenceFriday: (weekDay === 'Friday'),
        recurrenceSaturday: (dateConf && dateConf.recurrenceSaturday)? dateConf.recurrenceSaturday: (weekDay === 'Saturday'),
        recurrenceSunday: (dateConf && dateConf.recurrenceSunday)? dateConf.recurrenceSunday: (weekDay === 'Sunday'),
        dateRecurrenceMonthType: (dateConf && dateConf.dateRecurrenceMonthType)? dateConf.dateRecurrenceMonthType: 'MONTHDAY',
        dateRecurrenceEndType: (dateConf && dateConf.dateRecurrenceEndType)? dateConf.dateRecurrenceEndType: 'END_DATE',
        recurrenceEndDate: (dateConf && dateConf.recurrenceEndDateStringForInit)? new Date(dateConf.recurrenceEndDateStringForInit): new Date(),
        recurrenceEndOccurenceNumber: (dateConf && dateConf.recurrenceEndOccurenceNumber)? dateConf.recurrenceEndOccurenceNumber: 1
      })
    },

    // suppression d'une date
    removedProjectDateConf(projectDateConf){
      if (projectDateConf.id) {
        this.removedProjectDateConfsIds.push(projectDateConf.id)
      }
      this.projectDateConfs.splice(this.projectDateConfs.indexOf(projectDateConf), 1)
    },

    // envoi du save/update
    onSubmit() {

      let valid = this.checkFormValidity
      if (!valid) {
        return false
      }

      if (this.isSubmited) {
        this.isLoadingSubmited = true
      }
      else {
        this.isLoading = true
      }

      let data = new FormData()

      // évènement
      data.append('isSubmited', this.isSubmited)
      data.append('name', this.form.name.value)
      if (this.form.description.value) {
        data.append('description', this.form.description.value)
      }
      if (this.form.image.value) {
        data.append('image', this.form.image.value)
      }
      else if (this.form.image.id) {
        data.append('imageId', this.form.image.id)
      }
      if (this.form.commissionId.value) {
        data.append('commissionId', this.form.commissionId.value)
      }
      data.append('isFree', this.form.isFree.value)
      if (this.form.priceDetails.value) {
        data.append('priceDetails', this.form.priceDetails.value)
      }
      if (this.form.projectAccess.value) {
        data.append('projectAccess', this.form.projectAccess.value)
      }
      if (this.form.projectPublic.value) {
        data.append('projectPublic', this.form.projectPublic.value)
      }
      if (this.form.projectLink.value) {
        data.append('projectLink', this.form.projectLink.value)
      }
      if (this.form.facebookLink.value) {
        data.append('facebookLink', this.form.facebookLink.value)
      }
      if (this.form.instagramLink.value) {
        data.append('instagramLink', this.form.instagramLink.value)
      }
      if (this.form.userComment.value) {
        data.append('userComment', this.form.userComment.value)
      }
      if (this.form.projectStatus.value) {
        data.append('projectStatus', this.form.projectStatus.value)
      }
      if (this.form.isComRelevant.value) {
        data.append('isComRelevant', this.form.isComRelevant.value)
      }
      if (this.form.budgetNeeded.value) {
        data.append('budgetNeeded', this.form.budgetNeeded.value)
      }
      if (this.form.budget.value) {
        data.append('budget', this.form.budget.value)
      }
      if (this.form.commissionComment.value) {
        data.append('commissionComment', this.form.commissionComment.value)
      }
      if (this.displayMessage && this.form.message.value) {
        data.append('message', this.form.message.value)
      }

      // lieu
      if (this.form.place.name.value) {
        data.append('placeName', this.form.place.name.value)
      }
      if (this.form.place.address.value) {
        data.append('placeAddress', this.form.place.address.value)
        data.append('placeLatitude', this.form.place.address.latitude)
        data.append('placeLongitude', this.form.place.address.longitude)
        if (this.form.place.address.city) {
          data.append('placeCity', this.form.place.address.city)
        }
        if (this.form.place.address.department) {
          data.append('placeDepartment', this.form.place.address.department)
        }
      }
      if (this.form.place.phoneNumber.value) {
        data.append('placePhoneNumber', this.form.place.phoneNumber.formattedNumber)
        data.append('placePhoneCountryCode', this.form.place.phoneNumber.countryCode)
      }
      if (this.form.place.website.value) {
        data.append('placeWebsite', this.form.place.website.value)
      }

      // organisateur
      if (this.form.organizer.type.value) {
        data.append('organizerType', this.form.organizer.type.value)
      }
      if (this.form.organizer.name.value) {
      data.append('organizerName', this.form.organizer.name.value)
      }
      if (this.form.organizer.website.value) {
        data.append('organizerWebsite', this.form.organizer.website.value)
      }
      if (this.form.organizer.contactFirstname.value) {
        data.append('organizerContactFirstname', this.form.organizer.contactFirstname.value)
      }
      if (this.form.organizer.contactLastname.value) {
        data.append('organizerContactLastname', this.form.organizer.contactLastname.value)
      }
      if (this.form.organizer.contactPhoneNumber.value) {
        data.append('organizerContactPhoneNumber', this.form.organizer.contactPhoneNumber.formattedNumber)
        data.append('organizerContactPhoneCountryCode', this.form.organizer.contactPhoneNumber.countryCode)
      }
      if (this.form.organizer.contactEmail.value) {
        data.append('organizerContactEmail', this.form.organizer.contactEmail.value)
      }

      // projectTypes
      this.selectedProjectTypesIds.forEach ((projectTypeId) => {
        data.append('selectedProjectTypesIds', projectTypeId)
      })

      // projectDateConf supprimés
      this.removedProjectDateConfsIds.forEach((projectDateConfId) => {
        data.append('removedProjectDateConfsIds', projectDateConfId)
      })

      // projectDateConfs
      data.append('projectDateConfs', JSON.stringify(this.projectDateConfs))

      const url = this.isEdition? '/project/' + this.projectId : 'project'

      api({
        method: 'POST',
        url: url,
        data: data
      })
        .then((response) => {
          this.$router.push({
            name: 'ProjectShow',
            params: {
              projectId: response.data.id
            }
          }, () => {
            this.$nextTick(() => {
              this.successToast(response.data.tostring)
            })
          })
        })
        .catch((error) => {
          this.isLoadingSubmited = false
          this.isLoading = false
          this.isSubmited = false
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'ProjectIndex',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
          else if (error.response.status === 462) {
            this.errorToast((error.response.data.message))
          }
        })
    },

    // affichage de la modale de règlement
    showRulesModal(){
      this.$bvModal.show('project-rules-modal')
    },

    successToast (name) {
      this.$bvToast.toast(this.$i18n.t('Project') + ' "' + name + '" ' + (this.isEdition? this.$i18n.t('modified'): this.$i18n.t('added')), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    errorToast (message) {
      this.$bvToast.toast(this.$i18n.t(message), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/project/ProjectCreateEdit.vue